import { DecisionRadioCard } from "@/components/ui/decision-radio-card";
import { AppColors } from "@/styles/colors";
import { Flex } from "@chakra-ui/react";
import { DocDecision, SetDecisions } from "./types";

interface Props {
  docId: number;
  decision: DocDecision;
  disabled: boolean;
  showMustStartReviewToast: () => void;
  setDecisions: SetDecisions;
}

export const DecisionActions = ({
  docId,
  decision,
  disabled,
  showMustStartReviewToast,
  setDecisions,
}: Props) => {
  return (
    <Flex gap="12px" justifyContent="center">
      <DecisionRadioCard
        label="Aceptar"
        value="accept"
        variant="accept"
        checked={decision === "accept"}
        borderColor={
          decision === "accept" ? AppColors.LIGHT_GREEN : AppColors.GRAY_BORDER_1
        }
        disabled={disabled}
        onDisabledClick={showMustStartReviewToast}
        onChange={() => {
          if (disabled) {
            showMustStartReviewToast();
            return;
          }
          setDecisions((prev) => ({
            ...prev,
            [docId]: "accept",
          }));
        }}
      />

      <DecisionRadioCard
        label="Rechazar"
        value="reject"
        variant="reject"
        checked={decision === "reject"}
        borderColor={
          decision === "reject" ? AppColors.RED_ICON_ALT : AppColors.GRAY_BORDER_1
        }
        disabled={disabled}
        onDisabledClick={showMustStartReviewToast}
        onChange={() => {
          if (disabled) {
            showMustStartReviewToast();
            return;
          }
          setDecisions((prev) => ({
            ...prev,
            [docId]: "reject",
          }));
        }}
      />
    </Flex>
  );
};
